import { StoreEnvironment, StoreI18n, StoreSettings } from '../../../../Types/StoreTypes';
import ImageUpload from '../../../Utility/ImageUpload';
import { Button } from '../../../Utility/Button';
import { useThemeSettings } from '../../../../Hooks/useThemeSettings';

interface GeneralSettingsProps {
    SettingsActions: any;
    i18n: StoreI18n['i18n'];
    windowWidth: StoreEnvironment['windowWidth'];
    getBreakpoint: (breakpoint: string) => number;
    Currentsettings: StoreSettings;
}

function ThemeSettings({ SettingsActions, i18n, Currentsettings }: GeneralSettingsProps) {
    const { imagePreviewDark, imagePreviewLight, handleImageChange, handleRemoveImage } = useThemeSettings(
        Currentsettings,
        SettingsActions,
    );

    const imageUploadWidth = 'w-[300px]';
    const imageUploadHeight = 'h-[100px]';

    return (
        <div className="w-full flex gap-8 flex-col">
            <h4 className="block">{i18n.translate({ id: 'themeSettings', sourceName: 'Settings' })}</h4>

            <div className="flex flex-col w-full gap-5">
                <div className="w-full">
                    <label className="block mb-2">
                        {i18n.translate({ id: 'themeSettings.darkTheme', sourceName: 'Settings' }) || 'Dark Theme'}
                    </label>

                    <div className={`border p-0 ${imageUploadWidth} ${imageUploadHeight} border-layout-borderColor`}>
                        <ImageUpload
                            variant="box"
                            handleImageChange={(e) => {
                                handleImageChange(e, 'dark');
                            }}
                            handleRemoveImage={() => handleRemoveImage('dark')}
                            camRemoveImage={true}
                            imagePreview={imagePreviewDark}
                            customSettings={{
                                customBackgroundColor: 'bg-gray-900',
                                customForegroundColor: 'text-gray-100',
                                customHeight: imageUploadHeight,
                                customWidth: imageUploadWidth,
                            }}
                        ></ImageUpload>
                    </div>
                </div>

                <div className="w-full">
                    <label className="block mb-2">
                        {i18n.translate({ id: 'themeSettings.lightTheme', sourceName: 'Settings' }) || 'Light Theme'}
                    </label>

                    <div className={`border p-0 ${imageUploadWidth} ${imageUploadHeight} border-layout-borderColor`}>
                        <ImageUpload
                            variant="box"
                            handleImageChange={(e) => {
                                handleImageChange(e, 'light');
                            }}
                            handleRemoveImage={() => handleRemoveImage('light')}
                            camRemoveImage={true}
                            imagePreview={imagePreviewLight}
                            customSettings={{
                                customBackgroundColor: 'bg-gray-100',
                                customForegroundColor: 'text-gray-900',
                                customHeight: imageUploadHeight,
                                customWidth: imageUploadWidth,
                            }}
                        ></ImageUpload>
                    </div>
                </div>
            </div>

            <div className="mt-5 text-right">
                <Button onClick={SettingsActions.saveSettings}>
                    {i18n.translate({ id: 'save', sourceName: 'Main' })}
                </Button>
            </div>
        </div>
    );
}

export default ThemeSettings;
